import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom';
import Navbar from './Navbar'
import "./LandingPage.css"
import { NavLink } from 'react-router-dom'
import Footer from './Footer'
import "./RFQbutton.css"
import Popup from './Popup';
import Snackbar from "@material-ui/core/Snackbar";
import MuiAlert from "@material-ui/lab/Alert";
import { Helmet } from 'react-helmet';
import {  GrRefresh } from 'react-icons/gr';
import {  GoArrowRight } from 'react-icons/go';
import LoadingScreen from './LoadingScreen';
import { bringInData,sendInData } from '../service/api'
import { authenticateGetDetail,checkPerTonne, checkFreqLanes, checkPerKg  } from '../service/api'
import { LoginContext } from "../Contexts/ContextProvider";
import { useContext } from 'react'
import { bringInDataPerTon,sendInDataPerTon } from '../service/api'
import { bringInDataFreqLanes,sendInDataFreqLanes } from '../service/api'
import ProfileProgress from './ProfileProgress';
// import image_32 from '../images/image_32.png'
// import image_33 from '../images/image_33.png'
// import marco from '../images/marco.png'
// import exide from '../images/exide.png'
import { useHistory } from 'react-router-dom';
import { getAllTheRfqs } from '../service/api';


function RFQbutton() {
  
    
        const [loading,setLoading]=useState(true);
        const [posts,setPosts]=useState({});
        const [isOpenKg,setIsopenKg]=useState(false);
        const [isOpenTonne,setIsopenTonne]=useState(false);
        const [isOpenLanes,setIsopenLanes]=useState(false);
        const [uploadPc,setUploadPc]=useState("none");
        const [isOpenRfqs,setIsOpenRfqs]=useState(false);
        const [presentPerKg,setPresentPerKg]=useState(false);
        const [presentPerTonne,setPresentPerTonne]=useState(false);
        const [presentFreqlanes,setPresentFreqLanes]=useState(false);
        const [percentage,setPercentage]=useState(25);
        const [openSnackBar,setOpenSnackBar]=useState(false);
        const [severity,setSeverity]=useState("");
        const [msg,setMsg]=useState("");
        const [isOpenProgress,setIsOpenProgress]=useState(false);
        const [dispOther,setDispOther]=useState('none');
        const [diffInDays,setDiffInDays]=useState(0);
        const [dispPerKg,setDispPerKg]=useState('block');
        const [dispPerTon,setDispPerTon]=useState('block');
        const [dispPerFreq,setDispPerFreq]=useState('block');
        const [dispPerKgLast,setDispPerKgLast]=useState('none');
        const [dispPerTonLast,setDispPerTonLast]=useState('none');
        const [frequentLanes,setFrequentLanes]=useState([{
            from:"",
            to:"",
            type:""
        }])
        const [profile,setProfile]=useState('');
        // const [items,setItems]=useState([]);
        const {userEmail,account,setAccount,setUserEmail}=useContext(LoginContext);
        const history=useHistory();
        const {setRfqItem}=useContext(LoginContext);
    const items = [
        {
            Title:"Nagpur Operations",
            EstimatedMonthlyVolume:"100 Tones",
            ServiceType:"Per kg Basis",
            CloseDate:"01/02/2023",
            imgsrc:'/images/Marico.webp',
            CompanyName:"Marico Pvt Ltd",
            Place:"Nagpur, Maharashtra",
            Description:"Marico Limited is an Indian multinational consumer goods company providing consumer products and services in the areas of health, beauty and wellness. With its headquarters in Mumbai, Marico is present in over 25 countries across Asia and Africa. It owns brands in categories of hair care, skin care, edible oils, health foods, male grooming, and fabric care.It is currently looking for a 3PL in Nagpur to cater its transportation services in Nagpur Operations."
        },
        {
            Title:"Bhiwandi Adhoc lanes",
            EstimatedMonthlyVolume:"560 Tones",
            ServiceType:"Per kg Basis",
            CloseDate:"25/01/2023",
            imgsrc:'/images/exide.png',
            CompanyName:"Exide Industries",
            Place:"Bhiwandi, Maharashtra",
            Description:"Exide Industries Ltd, is an Indian multinational storage battery manufacturer company, headquartered in Kolkata. It is the largest manufacturer of automotive and industrial lead-acid batteries in India and fourth largest in the world.It is currently looking for a 3PL in Bhiwandi to cater its transportation services in additional lanes from Bhiwandi."
        }
    ];

    useEffect(() => {
            try{
                authenticateGetDetail().then((response)=>{setAccount(response.data)
                setUserEmail(response.data.Email)
                setPosts(response.data)
                const date1=new Date(response.data.registerDate)
                const date2=new Date(response.data.loginDate)
                const timing=Math.floor(Difference_In_Time / (1000 * 3600 * 24))
                if(timing>180){
                    document.getElementById("platinumMem").innerHTML="Regular";
                    document.getElementById("180Validation").innerHTML="Expired";
                }
                var Difference_In_Time = date2.getTime() - date1.getTime();
                setDiffInDays(Math.floor(Difference_In_Time / (1000 * 3600 * 24)))
            if(response.data.trucks && response.data.Revenue && response.data.Exp_Companies && response.data.Sector && response.data.Service){
                setDispOther('none');
            }
            else{
                setDispOther('block');
            }
        })
            setLoading(false);
            }
            catch(err){
                setOpenSnackBar(true);
                setSeverity("error");
                setMsg("Error:",err);
            }
        // try{
        //     getAllTheRfqs().then((response)=>{setItems(response.data)
        //     console.log(response.data);
        //     })    
        // }
        // catch(err){
        //     setOpenSnackBar(true);
        //     setSeverity("error");
        //     setMsg(err);
        // }

        
    }, [ ,sendInData,sendInDataFreqLanes,sendInDataPerTon])

    useEffect(()=>{
        ProgressPercentage()
    },[posts,presentPerKg,presentPerTonne,presentFreqlanes])
    
    useEffect(()=>{
        console.log(userEmail);
        checkPerKg({email:userEmail}).then((response)=>{if(response){setPresentPerKg(true)
        setDispPerKg('none')
        setDispPerKgLast('block')
    }}).catch(e=>{
        setOpenSnackBar(true);
        setSeverity("error");
        setMsg("Error:",e);
    })
        checkPerTonne({email:userEmail}).then((response)=>{if(response){setPresentPerTonne(true)
        setDispPerTon('none')
        setDispPerTonLast('block')
    }}).catch(e=>{
        setOpenSnackBar(true);
        setSeverity("error");
        setMsg("Error:",e);
    })
        checkFreqLanes({email:userEmail}).then((response)=>{if(response){setPresentFreqLanes(true)
        setDispPerFreq('none')
        setFrequentLanes(response.data.fileAoO);   
    }}).catch(e=>{
        setOpenSnackBar(true);
        setSeverity("error");
        setMsg("Error:",e);
    })
    },[userEmail,profile])


    useEffect(()=>{
        console.log(percentage);
        (percentage<100)?setIsOpenProgress(true):setIsOpenProgress(false);
    },[percentage])
function ProgressPercentage(){
    setPercentage(25);
    console.log(Object.keys(posts).length !== 0)
    if(Object.keys(posts).length !== 0){
      if(posts.trucks.length>0){
          setPercentage(prevItem=>prevItem+5)
          console.log(posts.trucks)
          console.log("trucks")
      }
      if(posts.Revenue!=="0"){
          setPercentage(prevItem=>prevItem+5)
          console.log(posts.Revenue)
          console.log("rev")
      }
          
      if(posts.Exp_Companies){
          setPercentage(prevItem=>prevItem+5)
          console.log(posts.Exp_Companies)
          console.log("exp")
      }
          
      if(posts.Sector.length>0){
          setPercentage(prevItem=>prevItem+5)
          console.log(posts.Sector)
          console.log("sec")
      }
          
      if(posts.Service){
          setPercentage(prevItem=>prevItem+5)
          console.log(posts.Service)
          console.log("ser")
      }
          
      // if(presentPerKg || presentPerTonne){
      //     setPercentage(prevItem=>prevItem+25)
      //     console.log("perkg")
      // }
      if(presentFreqlanes){
          setPercentage(prevItem=>prevItem+50)
          console.log("freq")
      }
    }
    return percentage;
  }

function formHandlerKg(e){
        e.preventDefault();
        const file=e.target[0].files[0];

        var fileInput = 
        document.getElementById('file-inp-kg');
        var filePath = fileInput.value;
         //Allowing file type
         var allowedExtensions = 
         /(\.xlsx)$/i;
   
 if (!allowedExtensions.exec(filePath)) {
     alert('No file found or Invalid File Format (.xlsx only allowed)');
   
 }
   else
   {
    // alert("file uploaded")
      
        fileHandlerKg(file);
        setUploadPc("block");
        // fetchFiles();
   }
    }
    
     const fileHandlerKg = async(file)=>{
          if(!file) return;


         // Math.round(new Date().getTime()/1000)
         const d=new Date();
         
         var time=d.getTime();
         var day=d.getDate();
         var month=d.getMonth();
         var yr=d.getFullYear();
         const filetime=time+""+day+""+month+""+yr;
         const data=new FormData();
         data.append('file',file);
         data.append('email',userEmail);
         const response=await sendInData(data).then(()=>{
            if(response.data){
                console.log("Success");
                setIsopenTonne(false);
                setUploadPc('none');
                setOpenSnackBar(true);
                setSeverity("success");
                setMsg("Saved File");
                setProfile(filetime);
                console.log(response);
            }
            else{
                setIsopenTonne(false);
                setUploadPc('none');
                setOpenSnackBar(true);
                setSeverity("error");
                setMsg("Bad Request");
            }
         }).catch((e)=>{
            setOpenSnackBar(true);
            setSeverity("error");
            setMsg("Error:",e);
         })
              
    };

    async function fetchFilesKg(){
        await bringInData({email:userEmail}).then((response)=>{
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'exportData.xlsx');
            document.body.appendChild(link);
            link.click();
             
         }).catch((e)=>{
            setOpenSnackBar(true);
            setSeverity("error");
            setMsg("Error:",e);
         });
         
    }
    
    //kg End

    //Tonne Start
    function formHandlerTonne(e){
        e.preventDefault();
        const file=e.target[0].files[0];
     

        var fileInput = 
        document.getElementById('file-inp-tonne');
        var filePath = fileInput.value;

         // Allowing file type
         var allowedExtensions = 
         /(\.xlsx)$/i;



   
 if (!allowedExtensions.exec(filePath)) {
     alert('No file found or Invalid File Format (.xlsx only allowed)');
   
 }
   else
   {
    // alert("file uploaded")
      
      fileHandlerTonne(file);
        setUploadPc("block");
        // fetchFiles();
  
     
   }
    }
    
     const fileHandlerTonne = async(file)=>{
        if(!file) return;


         // Math.round(new Date().getTime()/1000)
         const d=new Date();
         
         var time = d.getTime();
         var day = d.getDate();
         var month = d.getMonth();
         var yr = d.getFullYear();
         const filetime=time+""+day+""+month+""+yr;
        const data=new FormData();
         data.append('file',file);
        data.append('email',userEmail);
        await sendInDataPerTon(data).then((response)=>{
            if(response.data){
                console.log("Success");
                setIsopenTonne(false);
                setUploadPc('none');
                setOpenSnackBar(true);
                setSeverity("success");
                setMsg("Saved File");
                setProfile(filetime);
                console.log(response);
            }
            else{
                setIsopenTonne(false);
                setUploadPc('none');
                setOpenSnackBar(true);
                setSeverity("error");
                setMsg("Bad Request");
            }
         }).catch((e)=>{
            setOpenSnackBar(true);
            setSeverity("error");
            setMsg("Error:",e);
         })
        
           
    };

     async function fetchFilesTonne(){
        console.log("fetch Tn")
        await bringInDataPerTon({email:userEmail}).then((response)=>{
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'exportData.xlsx');
            document.body.appendChild(link);
            link.click();

         }).catch((e)=>{
            setOpenSnackBar(true);
            setSeverity("error");
            setMsg("Error:",e);
         });
         
    }

    //Tonne End

 //Lanes Start
 
async function fileHandlerLanes(){
    const d=new Date();
     var time=d.getTime();
     var day=d.getDate();
     var month=d.getMonth();
     var yr=d.getFullYear();
     const filetime=time+""+day+""+month+""+yr;
    var allFilled=true;
     frequentLanes.map(element=>{
         if(!element.from || !element.to || !element.type){
             console.log(false);
            allFilled=allFilled&&false;
         }
         else{
             console.log(true)
            allFilled=allFilled&&true;
         }
     })
     console.log(allFilled);
     if(allFilled){
    const response=await sendInDataFreqLanes({email:userEmail,fileAoO:frequentLanes}).then(()=>{
        console.log("Success");
            setIsopenLanes(false);
            setUploadPc('none');
            setOpenSnackBar(true);
            setSeverity("success");
            setMsg("Saved File");
            setProfile(filetime);
         }).catch((e)=>{
            setOpenSnackBar(true);
            setSeverity("error");
            setMsg("Error:",e);
         })
     }
    else{
        setOpenSnackBar(true);
        setSeverity("error");
        setMsg("Fill in all the fields before submitting");
     }
         
}


async function fetchFilesLanes(){
    console.log("fetch Fl")
    await bringInDataFreqLanes({email:userEmail}).then((response)=>{
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'exportData.xlsx');
        document.body.appendChild(link);
        link.click();

     }).catch((e)=>{
        setOpenSnackBar(true);
        setSeverity("error");
        setMsg("Error:",e);
     });
     
}


//Tonne End
    function Alert(props) {
        return <MuiAlert elevation={6} variant="filled" {...props} />;
      }
      const handleClose = (event, reason) => {
        if (reason === 'clickaway') {
          return;
        }

        setOpenSnackBar(false);
      };



    const handleFormChange = (index, event) => {
          console.log(event.target.name);
          console.log(event.target.value);
          let data = [...frequentLanes];
          data[index][event.target.name] = event.target.value;
          setFrequentLanes(data);
    }
    
      const addInput = () => {
        let newfield = { from:"",to:"",type:"" }

        setFrequentLanes([...frequentLanes, newfield])
      }

    const minusInput = (index) => {
        const arr1=[...frequentLanes];
        console.log(arr1);
        arr1.splice(index,1);
        console.log(arr1);
        setFrequentLanes(arr1);
    }
    function checkFreqTable(){
        if(frequentLanes.length<=1){
          return {display:'none'};
        }
        else{
          return {display:'block'}
        }
      }


    if (loading)
    {
        return(
            
        <LoadingScreen/>
        )
    }

    function checkStatus(item){
        if(item){
            if(item.status==="LIVE"){
                return "rgba(242, 193, 6, 1)";
            }
            else if(item.status==="MODIFY"){
                return "rgba(8, 128, 166, 1)";
            }
            else if(item.status==="CLOSED"){
                return "rgba(188, 188, 188, 1)";
            }
        }
    }

    function setRfqTitle(title){
        setRfqItem(title);
        history.push('/TenderPage');
    }

 
    return (

 
        <div className='entirePage'>
            {console.log(userEmail)}
            {console.log(posts)}
            <Helmet>
            <title>Transit Pro | Home</title>
            </Helmet>
            <Navbar/>
            <div id="row" >
            <div className="column-landing  col-left">
            <div className="miniProfile">
            {
                Object.keys(posts).length!==0?
                    <h2>{posts.Company}</h2>
                   :
                    <h2>Company pvt. Ltd.</h2>
            }

             
            <NavLink exact to="/profile" className="prof-link">View Profile</NavLink>
            <div id="prof-data">
               <h6>Profile Completion</h6>
                <ProfileProgress done={percentage} progress="progressmini" progressDone="progress-donemini" disp="none" />
            </div>
            <div id="prof-data">
               <h6>Competitive Rate</h6>
                <ProfileProgress key={0} done={0} progress="progressmini" progressDone="progress-donemini" disp="none" />
            </div>
            <div id="prof-data">
               <h6>Market Presence</h6>
                <ProfileProgress key={0} done={0} progress="progressmini" progressDone="progress-donemini" disp="none" />
            </div>

           <div className="member">
            <h5><b>Membership:</b> <span id='platinumMem' style={{color:'rgb(255, 99, 71)'}}>Premium</span></h5>
               {console.log(diffInDays>180)}
            <h6><strong>Validity</strong>:<span id="180validation">{180-diffInDays} Days</span></h6>
           </div>

         </div>
            <div className='rfqslive'>
                 <div className='Rfqs-ap'>
                    <p>RFQs applied</p>
                 </div>
                 <div className='Rfqs-pe'>
                    <p>Pending Decisions</p>
                 </div>
             </div>
         
         </div>
        
         {/* middle Column */}
         <div className="column-landing col-midut">
            <div className="rfq-Box ">
                <h3>LIVE RFQs</h3>
                <div className='utl-btn-div1' >
                    {items.map((item)=>(
                        <div id='card' onClick={()=>setRfqTitle(item)}>
                            <p className='placename'>{item.CompanyName}</p>
                            <img src={item.imgsrc} alt="logo" style={{width:'50px',height:'23px',margin:'10px'}}/>
                            <p className='statusRfq' style={{backgroundColor:/*checkStatus(item)*/"rgba(188, 188, 188, 1)"}}>CLOSED</p>
                            <p className='lastDaterfq'><b>Last Date:</b>{item.CloseDate}</p>
                        </div>
                    ))}
                    {/* <Popup  trigger={isOpenRfqs} setTrigger={setIsOpenRfqs} style="popup-inner">
                        <div className='RFQCLOSED'>
                            <h2 style={{borderBottom: '3px solid rgba(0, 0, 0, 0.15)'}}><strong>RFQ Closed</strong></h2>
                            <div className='RfqClosedPopup'>
                                <img src={image_32} alt="cross" style={{width:'50px'}}/>
                                <div>
                                    <h4>This RFQ has been closed</h4>
                                    <h6>Last Date was on 16/1/2022</h6>
                                </div>
                            </div>
                            <div className='RfqSymbolPopup'>
                                <img src={image_33} alt="symbol" style={{width:'50px'}}/>
                                <h4><strong>You will be notified whenever a new RFQ is floated</strong></h4>
                            </div>
                            <button className='RfqPopupSub' onClick={()=>history.push('/TenderPage')} >Sure</button>
                        </div>

                    </Popup> */}
                </div>
            </div>

         </div>

         {/* Right col */}
<div className="column-landing col-right ">
             {/* Util */}
             <div className="util">
                 <h3>My Utilities</h3>
                <Link className="bt-util" to="/RFQ"><span>RFQs</span></Link>
                 
                <Link className="bt-util" to="/Analytics"><span>My Analytics</span></Link>
                 
                <Link className="bt-util" to="/Quotations"><span>My Quotations</span></Link>
             </div>

             {/* Data */}
             <div className="data">
             <h3>My Data</h3>
             {/* <button className="bt-data" onClick={()=>setIsopenKg(true)}>Per Kg</button>


             <Popup trigger={isOpenKg} setTrigger={setIsopenKg}>
               <h2>My Data Per Kg</h2>
               <form className="pop-form" onSubmit={formHandlerKg}>
                   <div id="row-pop">
            <a id="upl-btn" href="https://firebasestorage.googleapis.com/v0/b/transit-pro-fdf25.appspot.com/o/files%2FTransit%20template%2FTransit%20TemplateKg.xlsx?alt=media&token=fa2f1606-6ede-49d9-b585-23f3647486a8">Download Template</a>
                   <div id="row-pop-inner"><GoArrowRight className="ico-pop"/>
                
                     <input type="file" id="file-inp-kg" />
                 <GoArrowRight className="ico-pop"/>
                 </div>
                    <button type="submit" id="upl-btn" >Upload</button>
                    </div>
                </form>
                    <p style={{display: uploadPc}}>Uploading...</p>
                  
                <div style={{display:dispPerKgLast}} >
                    <h5>Last Uploaded File</h5>
                    <button onClick={(e)=>{fetchFilesKg();
                    e.preventDefault();
                    
                    } }className="sub-btn btn-rfrsh" type="button"><GrRefresh/></button>
                        
                  
                  
                </div>

                          
               
             </Popup>
             
                 
                 <button className="bt-data"onClick={()=>setIsopenTonne(true)}>Per Tonne</button>

                 <Popup trigger={isOpenTonne} setTrigger={setIsopenTonne}>
                     <h2>My Data Per Tonne</h2>
                     <form className="pop-form" onSubmit={formHandlerTonne}>
                   <div id="row-pop">
            <a id="upl-btn" href="https://firebasestorage.googleapis.com/v0/b/transit-pro-fdf25.appspot.com/o/files%2FAdmin_Transit_Templates%2FPer%20tonne%20Data.xlsx?alt=media&token=f9a85c94-6f0e-407d-bb6d-3ee6136f9e2d">Download Template</a>
                   <div id="row-pop"><GoArrowRight className="ico-pop"/>
                 <input type="file" id="file-inp-tonne" style={{display:"block"}}/>
                 <GoArrowRight className="ico-pop"/>
                 </div>
                    <button type="submit" id="upl-btn" >Upload</button>
                    </div>
                </form>
                    <p style={{display: uploadPc}}>Uploading...</p>
                  
         
                <div style={{display:dispPerTonLast}}>
                    <h5>Last Uploaded File</h5>
                    <button  onClick={(e)=>{fetchFilesTonne();
                    e.preventDefault();
                    } }className="sub-btn btn-rfrsh" type="button"><GrRefresh/></button>
                  
                </div>
                        
                          
             </Popup> */}


             {/* Lanes  */}
                 
                 <button className="bt-data"onClick={()=>setIsopenLanes(true)}>Frequent Lanes</button>
                 <Popup trigger={isOpenLanes} setTrigger={setIsopenLanes}>
                     <h3><strong>Frequent Lanes</strong></h3>
                      <p><strong>Fill out lanes where your vehicles travel the regularly :</strong></p>
                      {console.log(frequentLanes)}
                <div className="favouriteLanesExcelPart">
                  {frequentLanes.map((input,index)=>{
                  return(
                    <div key={index} className="favouriteLanesData">
                        <div>
                            <label id="companyNameLabel">From<span style={{color:"red"}}>*</span></label>
                  <input
                    type="text"
                    id="From"
                    name="from"
                    className="inputCompany"
                    placeholder="From"
                    value={input.from}
                    onChange={event => handleFormChange(index, event)}
                    required
                  />
                  </div>
                  <div>
                <label id="companyNameLabel">To<span style={{color:"red"}}>*</span></label>
                <input
                    type="text"
                    id="To"
                    name="to"
                    className="inputCompany"
                    placeholder="To"
                    value={input.to}
                    onChange={event => handleFormChange(index, event)}
                    required
                  />
                  </div>
                  <div>
                <label id="companyNameLabel">Type</label>
                  <select
                  id="ServiceType"
                  name="type"
                  className="inputCompany"
                  defaultValue={input.type}
                  onChange={event => handleFormChange(index, event)}>
                      <option value="">-Service Type-</option>
                      <option value="FTL">FTL</option>
                      <option value="PTL">PTL</option>
                      <option value="Both">Both</option>
                  </select>
                  </div>
                    <div className='addMinusFreq'>
                    <div className="addFieldFavLanes" onClick={addInput}>+</div>
                    <div className='addFieldFavLanes' style={checkFreqTable()} onClick={()=>minusInput(index)}>-</div>
                    </div>
                  </div>
                  )
                  })}
                </div>  
                
                <div className="FavouriteLanesSubmitDiv">
                    {/* <div className="LastUpload">
                    <div className="LabelOfLastUpload"><h6>Last Uploaded File</h6></div>
                    <button onClick={(e)=>{fetchFilesLanes();
                    e.preventDefault();
                    } }className="button-refresh" type="button"><GrRefresh/></button>
                </div> */}
                <button onClick={fileHandlerLanes} className="submitButtonFavLanes">Submit</button>
                </div>        
               
             </Popup>
             </div>
         </div>
     </div>
     <Footer/>
        <Snackbar
            anchorOrigin={{ vertical:'bottom', horizontal:'left' }}
            open={openSnackBar}
            autoHideDuration={8000}
            onClose={handleClose}
            >
            <Alert onClose={handleClose} severity={severity}>
                {msg}
            </Alert>
          </Snackbar>
     </div>
    )
}


export default RFQbutton